import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const List = ({ headerItems, headerClasses, children }) => {
  return (
    <section className="items">
      <header className="header">
        <ul className="header__menu">
          {headerItems.map((headerItem, index) => {
            return (
              <li
                className={cn('header__menu-item', {
                  [headerClasses[0]]: headerClasses[1] === index,
                })}
                key={headerItem}
              >
                {headerItem}
              </li>
            )
          })}
        </ul>
      </header>
      <div className="item-list section">{children}</div>
    </section>
  )
}

List.propTypes = {
  headerItems: PropTypes.array,
  children: PropTypes.node,
  headerClasses: PropTypes.array,
}

List.defaultProps = {
  headerClasses: ['', 0],
}

export default List
